/*
================================================================================
FILE HEADER — apps/studio-web/src/components/TabPicker.tsx
================================================================================

CHANGE LOG
----------
| #  | Date       | Who               | Why               | What Changed        |
|----|------------|-------------------|-------------------|---------------------|
| 1  | 2026-06-23 | Claude Sonnet 4.6 | Phase 0           | Tab selection modal |

FILES THAT IMPORT THIS FILE
-----------------------------
- apps/studio-web/src/App.tsx

EXPORTS COVERED
---------------
- TabPicker — modal overlay showing open browser tabs to pick from
================================================================================
*/

import type { TabInfo } from '../extension/protocol.js';

type Props = {
  tabs: TabInfo[];
  onPick: (tab: TabInfo) => void;
  onClose: () => void;
};

export function TabPicker({ tabs, onPick, onClose }: Props) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999,
    }} onClick={onClose}>
      <div
        style={{
          background: '#18181b', border: '1px solid #3f3f46', borderRadius: 10,
          width: 480, maxHeight: '70vh', display: 'flex', flexDirection: 'column',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '14px 16px', borderBottom: '1px solid #27272a', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 600, fontSize: 14, color: '#e4e4e7' }}>Select a tab to record</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#71717a', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {tabs.length === 0 ? (
            <div style={{ padding: 24, textAlign: 'center', color: '#52525b', fontSize: 13 }}>
              No tabs found. Open a website in Chrome first.
            </div>
          ) : (
            tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => onPick(tab)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  width: '100%', padding: '10px 16px', background: 'none',
                  border: 'none', borderBottom: '1px solid #1c1c1f',
                  cursor: 'pointer', textAlign: 'left',
                }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = '#27272a'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = 'none'; }}
              >
                {tab.favIconUrl ? (
                  <img src={tab.favIconUrl} width={16} height={16} style={{ flexShrink: 0, borderRadius: 2 }} alt="" />
                ) : (
                  <div style={{ width: 16, height: 16, background: '#3f3f46', borderRadius: 2, flexShrink: 0 }} />
                )}
                <div style={{ overflow: 'hidden' }}>
                  <div style={{ fontSize: 13, color: '#e4e4e7', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tab.title}</div>
                  <div style={{ fontSize: 11, color: '#52525b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: 2 }}>{tab.url}</div>
                </div>
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
